
{
  "content": "This will use {proposedCampaignUsage} of your monthly {monthlyLimit} text message budget. You’ll have {remainingAfterProposedUsage} remaining for this month.",
  "error": "Failed to check usage limits",
  "would-exceed-limits": "This would exceed your monthly {monthlyLimit} text message budget. You have used {messagesSentUsage} this month. Try scheduling for another month."
}
